export enum MonitoringStatus {
  Planned = 'PLANNED',
  InProgress = 'IN_PROGRESS',
  Delivered = 'DELIVERED',
}

export enum ShipmentMonitoringStatus {
  Planned = 'PLANNED',
  InProgress = 'IN_PROGRESS',
  Delivered = 'DELIVERED',
  Closed = 'CLOSED',
}

export enum StatusAcceptanceType {
  Received = 'RECEIVED',
  Current = 'CURRENT',
  NotReceived = 'NOT_RECEIVED',
}

export enum ExportStatus {
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
}

export enum ExportType {
  AA = 'AA',
  SC1 = 'SC1',
  TrackAndTrace = 'TRACK_AND_TRACE',
  Address = 'ADDRESS',
  AddressExtended = 'ADDRESS_EXTENDED',
  Partner = 'PARTNER',
  USER = 'USER',
  QualitySC3 = 'QUALITY_SC3',
  QualitySC4 = 'QUALITY_SC4',
  Rule = 'RULE',
  DeliveryPerformance = 'DELIVERY_PERFORMANCE',
}
